import ApiSistema from '@/core/apis/ApiSistema';
import { IOcorrencia } from '@/models/Entidades/IOcorrencia';
import { IResposta } from '@/core/models/IResposta';
import { IServicoBase } from '@/core/models/IServicoBase';
import { IRepostaConsulta } from '@/core/models/IRepostaConsulta';
import { IOcorrenciaParametrosConsulta } from '@/models/ParametrosRequisicao/Consulta/IOcorrenciaParametrosConsulta';
import { IDTOOcorrencia } from '@/models/DTO/IDTOOcorrencia';
import { IParametrosBuscaRapida } from '@/core/models/Consulta/IParametrosBuscaRapida';
import { IItemBuscaRapida } from '@/core/models/Consulta/IItemBuscaRapida';
import { EStatusOcorrencia } from '@/models/Enumeradores/EStatusOcorrencia';
import { IRetornoRelatorio } from '@/core/models/IRetornoRelatorio';
import { IDefinicaoOcorrencia } from '@/models/Entidades/IDefinicaoOcorrencia';
/**
 * Serviço de Ocorrencias
 */

class ServicoOcorrencia implements IServicoBase<IOcorrencia> {
  endPoint = 'ocorrencias';

  apiSistema = new ApiSistema();

  public async incluir(ocorrencia: IOcorrencia): Promise<IResposta> {
    const result: any = await this.apiSistema.post(`${this.endPoint}`, ocorrencia);
    return result.data;
  }

  public async gerarPdf(codigo:number): Promise<IRetornoRelatorio> {
    const result: any = await this.apiSistema.post(`${this.endPoint}/${codigo}/imprimir`);
    return result.data;
  }

  public async atualizar(ocorrencia: IOcorrencia): Promise<IResposta> {
    const result: any = await this.apiSistema.put(`${this.endPoint}/${ocorrencia.codigo}`, ocorrencia);
    return result.data;
  }

  public async obter(codigo: number): Promise<IOcorrencia> {
    const result: any = await this.apiSistema.get(`${this.endPoint}/${codigo}`);
    return result.data;
  }

  public async obterDefinicaoOcorrenciaPorTipo(codigoTipo: number): Promise<IDefinicaoOcorrencia> {
    const result: any = await this.apiSistema.get(`${this.endPoint}/definicoes/tipo/${codigoTipo}`);
    return result.data;
  }

  public async obterOcorrencias(parametrosConsulta: IOcorrenciaParametrosConsulta): Promise<IRepostaConsulta<IDTOOcorrencia>> {
    let parametrosAdicionais = '';

    if (parametrosConsulta.valorPesquisa !== undefined) {
      parametrosAdicionais += `?ValorPesquisa=${parametrosConsulta.valorPesquisa}`;
    }

    if (parametrosConsulta.apenasComCordenadas !== undefined) {
      parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
      parametrosAdicionais += `ApenasComCordenadas=${parametrosConsulta.apenasComCordenadas}`;
    }

    if (parametrosConsulta.status !== undefined) {
      parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
      parametrosAdicionais += `Status=${parametrosConsulta.status}`;
    }

    if (parametrosConsulta.numeroPagina !== undefined && parametrosConsulta.numeroPagina > 0) {
      parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
      parametrosAdicionais += `NumeroPagina=${parametrosConsulta.numeroPagina}`;
    }
    if (parametrosConsulta.qtdeRegistrosPagina !== undefined && parametrosConsulta.qtdeRegistrosPagina > 0) {
      parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
      parametrosAdicionais += `QtdeRegistrosPagina=${parametrosConsulta.qtdeRegistrosPagina}`;
    }
    if (parametrosConsulta.qtdeRegistrosTotal !== undefined && parametrosConsulta.qtdeRegistrosTotal > 0) {
      parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
      parametrosAdicionais += `QtdeRegistrosTotal=${parametrosConsulta.qtdeRegistrosTotal}`;
    }
    if (parametrosConsulta.ordenacao !== undefined) {
      parametrosConsulta.ordenacao.forEach((item) => {
        parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
        parametrosAdicionais += `Ordenacao=${item}`;
      });
    }
    if (parametrosConsulta.codigos !== undefined) {
      parametrosConsulta.codigos.forEach((codigo) => {
        parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
        parametrosAdicionais += `Codigos=${codigo}`;
      });
    }
    const result: any = await this.apiSistema.get(`${this.endPoint}${parametrosAdicionais}`);
    return result.data;
  }

  public async buscaRapida(parametrosConsultaRapida: IParametrosBuscaRapida): Promise<IItemBuscaRapida[]> {
    const parametros = this.apiSistema.obterParametrosBuscaRapida(parametrosConsultaRapida);
    const result: any = await this.apiSistema.get(`${this.endPoint}/busca-rapida${parametros}`);
    return result.data;
  }

  public async deletar(codigo: number): Promise<IResposta> {
    const result: any = await this.apiSistema.delete(`${this.endPoint}/${codigo}`);
    return result.data;
  }

  public obterNomeStatus(status: EStatusOcorrencia): string {
    let nomeStatus = '';
    switch (status) {
      case EStatusOcorrencia.Aberta:
        nomeStatus = 'Aberta';
        break;

      case EStatusOcorrencia.EmAtendimento:
        nomeStatus = 'Em Atendimento';
        break;

      case EStatusOcorrencia.Concluida:
        nomeStatus = 'Concluída';
        break;

      case EStatusOcorrencia.Cancelada:
        nomeStatus = 'Cancelada';
        break;

      default:
        break;
    }

    return nomeStatus;
  }
}

export default ServicoOcorrencia;
